export const AgreeToPPAndTCMessage = {
	title: "Agree",
	description: "Agree to Privacy Policy and Terms and Conditions",
};
